import { createLocalStorageStateHook } from "use-local-storage-state";

export interface ISettings {
  notifications: {
    orderChat: boolean;
    moneyChat: boolean;
    order: boolean;
  };
  toolbar: boolean;
}

const useSettings = createLocalStorageStateHook<ISettings>("settings", {
  notifications: {
    orderChat: true,
    moneyChat: true,
    order: true,
  },
  toolbar: false
});

export default useSettings;
